const md5 = require('md5')

const inputCodeToEncryptedCode = (input) => {
  const withoutDashes = input.replace(/-/g, "");
  return md5(withoutDashes.toLowerCase());
}

module.exports = inputCodeToEncryptedCode
